import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {};

export default class Breadcrumbs extends Component {
  static selector = '.breadcrumb';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.scrollToEnd();
  }

  scrollToEnd() {
    this.$container.scrollLeft = this.$container.scrollWidth;
  }
}
